<template>
  <div class="print-container" style="overflow: hidden !important;">
    <div v-if="isLoading">
      <spinner-hoory />
    </div>
    <div v-else class="print-row">
      <p>Show private notes & activity logs</p>
      <woot-switch v-model="hasPrivate" size="18" @input="handlePrivate" />
    </div>
    <div class="modal-footer">
      <div class="modal-footer__buttons">
        <button class="button clear" @click.prevent="onCancel">
          {{ $t('EMAIL_TRANSCRIPT.CANCEL') }}
        </button>
        <woot-submit-button
          :disabled="isLoading || !conversations.length"
          button-text="Print"
          @click="onPrint"
        />
      </div>
    </div>
    <print-template
      v-if="showPrinter"
      ref="printer"
      :conversations="conversations"
      :header-data="dataHeader"
      class="print-template-hidden"
      @print-start="onPrintStart"
      @print-complete="handlePrintComplete"
    />
  </div>
</template>

<script>
import PrintTemplate from './PrintTemplate.vue';
import { mapGetters } from 'vuex';
import { INBOX_TYPES_NAME } from '../../../../../shared/mixins/inboxMixin';
import SpinnerHoory from '../../../../../shared/components/SpinnerHoory.vue';

export default {
  name: 'PrintTranscriptForm',
  components: { SpinnerHoory, PrintTemplate },
  props: {
    currentChat: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      hasPrivate: false,
      showPrinter: false,
      conversations: [],
      isLoading: false,
    };
  },
  computed: {
    ...mapGetters({
      allMessages: 'getAllMessages',
    }),
    dataHeader() {
      return {
        client: this.currentChat.meta?.sender?.name || '',
        clientEmail: this.currentChat.meta?.sender?.email || 'N/A',
        startTime: this.dateFormater(this.currentChat.created_at || 0) || '',
        status: this.currentChat.status || '',
        channel:
          INBOX_TYPES_NAME[
            this.currentChat?.channel || this.currentChat?.meta?.channel
          ] || '',
        agent: this.currentChat.meta?.assignee?.name || 'None',
        conversationId: this.currentChat.id || 'N/A',
      };
    },
  },
  async mounted() {
    this.isLoading = true;
    const response = await this.$store.dispatch('fetchAllMessages', {
      conversationId: this.currentChat.id,
    });
    this.formattedConversations(response);
    this.isLoading = false;
  },
  methods: {
    formattedConversations(messages) {
      const dataWithoutPrivateAndLogs = !this.hasPrivate
        ? messages.filter(
            message => message.private === false && !!message?.sender
          )
        : messages;

      this.conversations = dataWithoutPrivateAndLogs.map(message => {
        const senderName =
          message.sender?.type === 'contact'
            ? message.sender?.name
            : message.sender?.available_name || message.sender?.name;
        const timestamp = this.dateFormater(message.created_at);

        return {
          assistantType: message.sender?.assistant_type,
          contentType: message.content_type,
          contentAttributes: message?.content_attributes,
          sender: senderName,
          timestamp,
          content: message.content || '',
          isPrivate: this.hasPrivate ? message.private : false,
          attachments: message.attachments || [],
          isBot: message.sender?.type === 'agent_bot',
        };
      });
    },
    dateFormater(timestamp) {
      return new Date(timestamp * 1000).toLocaleString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      });
    },
    handlePrivate() {
      this.formattedConversations(this.allMessages);
    },
    onCancel() {
      this.$emit('on-cancel');
    },
    onPrint() {
      this.showPrinter = true;
      this.$nextTick(() => {
        this.$refs.printer.printCurrentView();
      });
    },
    handlePrintComplete() {
      this.showPrinter = false;
      this.onCancel();
    },
    onPrintStart(loading) {
      this.isLoading = loading;
    },
  },
};
</script>

<style lang="scss" scoped>
.print-container {
  padding: 0 2.4rem;
}
.print-row {
  display: flex;
  justify-content: space-between;
  padding: var(--space-medium) 5px;
}
.modal-footer {
  display: flex;
  justify-content: flex-end;
  padding: var(--space-medium) 5px !important;
  &__buttons {
    display: flex;
    align-items: center;
    gap: var(--space-small);
  }
}
.print-template-hidden {
  position: absolute;
  left: -9999px; // Move off-screen
  opacity: 0; // Ensure it's not visible
}
</style>
